/**
 * Light / dark toggle. The saved choice is applied before first paint by an inline script in snippets/pt-theme-mode.liquid;
 * this module only handles clicks: it flips <html data-theme>, keeps the choice in localStorage ("pt-theme"), and keeps the
 * button's label and aria-pressed in step. Every toggle on the page (header and mobile) stays in sync.
 */
const root = document.documentElement;
const buttons = () => [...document.querySelectorAll('[data-pt-theme-toggle]')];

function isLight() {
  return root.getAttribute('data-theme') === 'light';
}

function sync() {
  const light = isLight();
  for (const button of buttons()) {
    button.setAttribute('aria-pressed', String(light));
    button.setAttribute('aria-label', light ? button.dataset.labelToDark : button.dataset.labelToLight);
  }
}

function setTheme(light) {
  if (light) root.setAttribute('data-theme', 'light');
  else root.removeAttribute('data-theme');
  try {
    localStorage.setItem('pt-theme', light ? 'light' : 'dark');
  } catch {
    // private mode or blocked storage: the choice still applies to this page view
  }
  sync();
}

document.addEventListener('click', (event) => {
  if (event.target instanceof Element && event.target.closest('[data-pt-theme-toggle]')) setTheme(!isLight());
});

// another tab changed the choice
window.addEventListener('storage', (event) => {
  if (event.key !== 'pt-theme') return;
  if (event.newValue === 'light') root.setAttribute('data-theme', 'light');
  else root.removeAttribute('data-theme');
  sync();
});

sync();
// header buttons can be re-rendered by the theme editor
document.addEventListener('shopify:section:load', sync);
